import { supabase } from '@/core/database/supabase';
import type { ReworkStats } from '../types/construction-rework.types';

export const ConstructionReworkStatsService = {
  async getReworkStats(companyId: string, projectId?: string): Promise<ReworkStats> {
    let query = supabase
      .from('construction_rework_orders')
      .select('status_code, severity_code, actual_cost')
      .eq('company_id', companyId);
      
    if (projectId) query = query.eq('project_id', projectId);

    const { data, error } = await query;
    if (error) throw error;

    const items = data || [];
    const openStatus = ['approved', 'assigned', 'in_progress', 'reinspection_pending'];
    const openCount = items.filter(i => openStatus.includes(i.status_code)).length;
    const criticalCount = items.filter(i => i.severity_code === 'critical' || i.severity_code === 'high').length;
    const totalCost = items.reduce((sum, i) => sum + (i.actual_cost || 0), 0);

    return {
      totalOrders: items.length,
      openCount,
      criticalCount,
      totalActualCost: totalCost,
      avgResolutionTime: 0, 
    };
  }
};
